import styled from "@emotion/styled";

export const Wrapper = styled.div<{ padding: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  overflow: hidden;
  background: var(--clear-white);
  main {
    min-height: 100vh;
    overflow: auto;
    padding-top: ${({ padding }) => (padding ? "68px" : "0")};
    transition: padding-top 0.28s ease;
  }
`;
